import React from 'react';
import UserIcon from '../../img/UserIcon.png';
import Button from "@mui/material/Button";
import UserInfo from '../../components/UserInfo';
import TempUser from '../../components/TempUser';
import styles from './loggedInHomeComponents.module.css';

const user = new UserInfo(TempUser);

const EditProfileComponent = () => {

	const buttonStyle ={
    	borderRadius: 0,              
    	borderWidth: '4px',           
    	borderColor: 'black',         
    	color: 'black',
    	fontSize:'20px',
    	fontWeight:'bold',
    	ml: 2,
    	'&:hover': {
    		borderColor: 'black',
      		backgroundColor: 'rgba(0,0,0,0.05)', 
    	}
    }

	return (
		<div className={styles.EPMainBox}>
    		<img src={UserIcon} alt="Loading Error" className={styles.EPImage}/>
      		<div className={styles.EPUserName}>
				{user.name}
			</div>
      		<div style={{marginTop:"10px"}}>
				{user.location}
			</div>
      		<div>
				{user.email}
			</div>
      		<div>
				Member since: {user.startDate}
			</div>
      		<div className={styles.EPLastLoginBox}>Last Login: {user.lastLogin}</div>
      		<div className={styles.EPButtonsBox}>
        		<Button variant="outlined" sx={buttonStyle}>Edit your profile</Button>
        		<Button variant="outlined" sx={buttonStyle}>Delete your profile</Button>
      		</div>
    	</div>
  );
};

export default EditProfileComponent;